<template>
  <div>
    <vxe-toolbar
      id="toolbarId_sy81"
      :loading="loading"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('paidRecord_consume_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('paidRecord_consume_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      :loading="loading"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      height="500"
      @sort-change="sortList"
    >
      <!--      <vxe-table-column>-->
      <!--        <vxe-table-column-->
      <!--          field="type"-->
      <!--          title="三方接口类型"-->
      <!--          width="160"-->
      <!--          sortable-->
      <!--        >-->
      <!--          <template v-slot="{row}">-->
      <!--            {{ typeThird[row.typeThird] }}-->
      <!--          </template>-->
      <!--        </vxe-table-column>-->
      <!--        <template v-slot:header>-->
      <!--          <el-select v-model="listQuery.typeThird" clearable placeholder="请选择三方接口类型">-->
      <!--            <el-option v-for="(v,k) in typeThird" :key="k" :label="v" :value="k" />-->
      <!--          </el-select>-->
      <!--        </template>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          field="typeCharge"
          title="收费类型"
          width="160"
          sortable
        >
          <template v-slot="{row}">
            {{ typeCharge[row.typeCharge] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select v-model="listQuery.typeCharge" clearable placeholder="请选择收费类型">
            <el-option v-for="(v,k) in typeCharge" :key="k" :label="v" :value="k" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="interf"
          title="接口"
          width="200"
          sortable
        >
          <template v-slot="{row}">
            {{ interf[row.interf] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select v-model="listQuery.interf" clearable placeholder="请选择接口">
            <el-option v-for="(v,k) in interf" :key="k" :label="v" :value="k" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="consumeFee" title="消费金额" width="100" sortable />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="创建时间" width="240" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            class="unite-data"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="description" title="描述" min-width="160" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.description" placeholder="请输入描述" clearable />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request"
export default {
  name: "ChargetLog",
  components: {},
  data() {
    return {
      type: '',
      typeThird: {},
      typeCharge: {},
      interf: {},
      loading: false,
      tableData: [],
      listQuery: {},
          exportObj:{
        exportUrl:"/ntocc-basic-api/paidRecord/exportConsumeLogList",//导出接口
        name:'消费记录'
        },
      listQueryEmpty:{
        gmtCreatedRange: [],
        type: "",
        typeThird: "",
        typeCharge: "",
        interf: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
  },
  methods: {
    init(type, dict){
      this.listQuery = Object.assign({},this.listQueryEmpty)
      this.tableData = []
      this.gmtCreatedRange = []
      if (type) {
        this.type = type
        this.typeThird = {}
        this.typeCharge = {}
        this.interf = {}
        this.$set(this,'typeThird',dict.typeThird)
        this.$set(this,'typeCharge',dict.typeCharge)
        this.$set(this,'interf',Object.assign({},dict.interf[type]))
        this.listQuery.type = type
        this.initQuery = JSON.stringify(this.listQuery)
        this.findList()
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/paidRecord/consumeLog",
          method: "get",
          params: this.listQuery
        }).then(response => {
          //console.log(response);
          this.loading = false;
          this.tableData = response.data.records;
          let total = response.data.total
          this.listQuery.total = total
          resolve();
        });
      });
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>
